<template>
  <section class="ON_main_article_area ON_single_post_column ON_100px_padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="ON_main_article_details">
            <img class="img-fluid" :src="contents.image" alt="" />
            <a :href="contents.article_url" target="_blank"
              ><h4>{{ contents.title }} <br /></h4
            ></a>
            <div class="ON_article_basic_information">
              <div class="float-left">
                <p><b v-tooltip.top-center="hoverTips.label">Labels:</b></p>
                <ul class="unordered-list">
                  <li v-for="(label, index) in contents.labels" :key="index">
                    {{ label }}
                  </li>
                </ul>
              </div>
              <div class="float-right">
                <div class="media">
                  <div class="media-body">
                    <h5 v-tooltip.top-center="hoverTips.source">
                      Source: {{ contents.source }}
                    </h5>
                    <p>{{ convertEpoch(contents.addition_time) }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ON_article_basic_information">
              <div class="float-left">
                <a
                  :href="contents.article_url"
                  target="_blank"
                  v-tooltip.top-center="hoverTips.source"
                  >Article Source</a
                >
              </div>
              <div class="float-left">
                <a
                  :href="contents.article_url"
                  target="_blank"
                  v-tooltip.top-center="hoverTips.category"
                  >{{ contents.category }}</a
                >
              </div>

              <div class="float-left">
                <hr />
                <div class="media-body">
                  <h5 v-tooltip.top-center="hoverTips.sourceDescription">
                    Source Description:
                  </h5>
                  <p v-html="checkSource(descriptionForFunc, urlForDesc)"></p>
                </div>
              </div>
              <div class="float-left">
                <hr />
                <div class="media-body">
                  <h5 v-tooltip.top-center="hoverTips.perusivness">
                    Perusivness:
                  </h5>
                  <p>
                    {{ contents.perusivness }}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <blockquote class="blockquote">
              <h5 v-tooltip.top-center="hoverTips.summary">Summary:</h5>
              <p class="mb-0">
                {{ contents.summary }}
              </p>
              <details>
                <summary v-tooltip.top-center="hoverTips.keywords"
                  >Keywords</summary
                >
                <ul class="unordered-list">
                  <li v-for="keyword in contents.keywords" :key="keyword">
                    {{ keyword }}
                  </li>
                </ul>
              </details>
            </blockquote>

            <div class="section-top-border">
              <h4
                class="mb-30 ON_title_color"
                v-tooltip.top-center="hoverTips.articleAnalysis"
              >
                Article Analysis
              </h4>
              <div class="row">
                <div class="col-md-4">
                  <div class="single-defination">
                    <h3 class="mb-20" v-tooltip.top-center="hoverTips.apsga">
                      Associated Press Stylistic Guidelines analysis
                    </h3>
                    <p>{{ contents.ap_style_scores }}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="single-defination">
                    <h3
                      class="mb-20"
                      v-tooltip.top-center="
                        hoverTips.sentimentAndObjectivity.mainDescription
                      "
                    >
                      Sentiment and Objectivity
                    </h3>
                    <ul>
                      <li
                        v-tooltip.top-center="
                          hoverTips.sentimentAndObjectivity.objectivity
                        "
                      >
                        {{ contents.objectivity }}
                      </li>
                      <li
                        v-tooltip.top-center="
                          hoverTips.sentimentAndObjectivity.Sentiment
                        "
                      >
                        {{ contents.overall_sentiment }}
                      </li>
                      <li
                        v-tooltip.top-center="
                          hoverTips.sentimentAndObjectivity.pants_on_fire
                        "
                      >
                        {{ contents.pants_on_fire }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="single-defination">
                    <h3
                      class="mb-20"
                      v-tooltip.top-center="
                        hoverTips.sentimentAndObjectivity.truthinessScore
                      "
                    >
                      Truthiness Score
                    </h3>
                    <p>{{ contents.truthiness }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="ON_article_footer">
              <link
                href="https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext"
                rel="stylesheet"
              /><a
                class="bmc-button"
                target="_blank"
                href="https://www.buymeacoffee.com/objectiveNews"
                ><img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt="Buy us a coffee"
                /><span style="margin-left:5px;font-size:19px !important;"
                  >Buy us a coffee</span
                ></a
              >
              <div class="ON_article_socials ml-auto">
                <ShareNetwork
                  network="facebook"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  :hashtags="hashTags"
                  quote="Objective-News - We stand in the middle"
                  ><i class="fa fa-facebook"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="twitter"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  ><i class="fa fa-twitter"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="reddit"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  :hashtags="hashTags"
                  ><i class="fa fa-reddit"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="email"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  :description="shortSummary"
                  ><i class="fa fa-envelope"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="linkedin"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  :description="shortSummary"
                  ><i class="fa fa-linkedin"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  :description="shortSummary"
                  ><i class="fa fa-whatsapp"></i
                ></ShareNetwork>
                <ShareNetwork
                  network="xing"
                  :url="
                    'https://objective-news.com/' +
                      this.$route.name +
                      '/' +
                      this.id
                  "
                  :title="socialTitle"
                  ><i class="fa fa-xing"></i
                ></ShareNetwork>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="ON_right_side_column">
            <aside class="ON_right_items ON_ad_items text-center"></aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/fb";
import { convertEpoch } from "../convertEpoch.js";
import { toolTipText } from "../toolTipText.js";

export default {
  mixins: [convertEpoch, toolTipText],
  data() {
    return {
      contents: "",
      endIteration: 20,
      shortSummary: "",
      hashTags: "",
      socialTitle: "",
      descriptionForFunc: "",
      urlForDesc: "",
      hoverTips: {
        label: "This area shows labels identified in the article.",
        source: "Article Source.",
        sourceLink: "Article source URL.",
        category: "Article category.",
        sourceDescription: "Short description of Article source.",
        perusivness:
          "Proprietary method of identifying key points in the article, and quantifying 'readibility' of a given article.",
        summary:
          "Summarization of article, presenting all relevant items from the article in short, digestible summary.",
        keywords:
          "Keywords identified from the article, representing most relevant points described.",
        articleAnalysis:
          "Our analysis of the text itself, giving relevant information about the article",
        apsga:
          "Associated Press Stylistic analysis, verification of article stylistic representation and style",
        sentimentAndObjectivity: {
          mainDescription:
            "Analysis of sentiment, objectivity and realism of article",
          objectivity: "Analysis wether article is subjective or objective",
          sentiment:
            "Analysis of article polarity, represented by positive, negative and neutral",
          pantsOnFire: "Truthness of the article",
          truthinessScore:
            "Score given regarding facts presented in the article"
        }
      }
    };
  },
  props: ["id"],
  methods: {
    checkSource(stringToCheck, urlOfArticle) {
      if (stringToCheck.length <= 15) {
        return (
          "Source description not yet available, stay tuned, once description is available it will be posted here. Find out more at: " +
          urlOfArticle.split("/")[2]
        );
      } else {
        return (
          stringToCheck + " Find out more at: " + urlOfArticle.split("/")[2]
        );
      }
    }
  },
  created() {
    db.collection(this.$route.name)
      .doc(this.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.contents = doc.data();
          document.title = this.contents.title;
          this.descriptionForFunc = this.contents.source_description;
          this.urlForDesc = this.contents.article_url;
        } else {
          console.log("No such document!");
        }
      })
      .catch(error => {
        console.log("Error getting document:", error);
      });
    window.scrollTo(0, 0);
  }
};
</script>
